import { DefaultButton, Dialog, DialogType, IButtonStyles, Icon, IDialogContentProps, IIconStyles, PrimaryButton, Stack } from "@fluentui/react";
import themeBase from "../../utils/theme/themeBase";
import { LineProgress, SimmerProgress } from "../indicadores/Load";
import { ButtonFormPanel } from "./buttonForm";

interface IDialogDeleteBase {
    hidden: boolean | undefined,
    onDismiss: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void,
    hidePropressDelete: boolean,
    eliminar?: React.MouseEventHandler<HTMLSpanElement | HTMLAnchorElement | HTMLButtonElement | HTMLDivElement> | undefined,
    cancelar: React.MouseEventHandler<HTMLSpanElement | HTMLAnchorElement | HTMLButtonElement | HTMLDivElement> | undefined,
    // eliminar?: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void,
    // cancelar: (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void,
}

function DialogDeleteBase(props: IDialogDeleteBase) {

    const name = () => {
        return <div>
            <Icon iconName="ShieldAlert" styles={IconStyles} />
            <span style={{ color: themeBase.colorsBaseMessaging.SevereWarningIcon }}>  Eliminar Registro !</span>
        </div>
    }

    const dialogContentProps: IDialogContentProps = {
        type: DialogType.largeHeader,
        title: name(),
        subText: '',
    };

    return (
        <>
            <Dialog
                hidden={props.hidden}
                onDismiss={props.onDismiss}
                dialogContentProps={dialogContentProps}
            >
                <div style={{ minWidth: 300, minHeight: 50 }}>
                    {props.hidePropressDelete ?
                        <LineProgress disabled={false} prefix="Eliminando registro ..." />
                        : <SimmerProgress prefix="El registro se eliminara de forma permanente" disabled={false} />
                    }
                </div>
                <br />
                <Stack horizontal tokens={themeBase.StackTokens10} horizontalAlign='end'>
                    <DefaultButton
                        text='Cancelar'
                        onClick={props.cancelar}
                        allowDisabledFocus
                        // disabled
                        styles={CancelButtonStyle}
                    />
                    <PrimaryButton
                        text='Eliminar'
                        onClick={props.eliminar}
                        allowDisabledFocus
                        // disabled
                        styles={DeleteButtonStyle}
                    />
                </Stack>
                {/* <ButtonFormPanel register={props.eliminar} back={props.cancelar} textRegister="Eliminar"></ButtonFormPanel> */}
            </Dialog>
        </>
    );
}

export default DialogDeleteBase;

// ESTILOS
const DeleteButtonStyle: IButtonStyles = {
    root: {
        backgroundColor: themeBase.colorsBaseMessaging.SevereWarningIcon,
        border: 'none'
    },
    rootHovered: {
        backgroundColor: themeBase.colorsBaseMessaging.ErrorBlockIcon,
        border: 'none'
    }
}
const CancelButtonStyle: IButtonStyles = {
    root: {
        // backgroundColor: themeBase.colorsBaseMessaging.ErrorBlock,
        marginRight: 10
    }
}

const IconStyles: IIconStyles = {
    root: {
        fontSize: 32,
        color: themeBase.colorsBaseMessaging.SevereWarningIcon
    }
}